import { NgModule } from '@angular/core';
import { angularProvidersBuilder } from '@harmony/angular';
import { Functions } from 'firebase/functions';
import { RemoteConfig } from 'firebase/remote-config';
import { FirebaseToken } from '../../app/core/firebase.module';
import { CancelSubscriptionInteractor } from './domain/interactors/cancel-subscription.interactor';
import { ChangeSubscriptionInteractor } from './domain/interactors/change-subscription.interactor';
import { CreateSubscriptionInteractor } from './domain/interactors/create-subscription.interactor';
import { GetCustomerPortalUrlInteractor } from './domain/interactors/get-customer-portal-url.interactor';
import { GetPaymentResultInteractor } from './domain/interactors/get-payment-result.interactor';
import { GetPaywallDetailsInteractor } from './domain/interactors/get-paywall-details.interactor';
import { GetUpgradeProrationInteractor } from './domain/interactors/get-upgrade-proration.interactor';
import { PurchasesDefaultProvider, PurchasesProvider } from './purchases.provider';
import { GetPaymentMetadataInteractor } from './domain/interactors/get-payment-metadata.interactor';
import { SavePaymentMetadataInteractor } from './domain/interactors/save-payment-metadata.interactor';
import { WaitPurchaseWebhookInteractor } from './domain/interactors/wait-purchase-webhook.interactor';
import { AuthProvider } from '../auth/auth.provider';
import { Firestore } from 'firebase/firestore';
import { TeamProvider } from '../team/team.provider';
import { SyncTeamSubscriptionInteractor } from './domain/interactors/sync-team-subscription.interactor';

@NgModule({
  providers: angularProvidersBuilder({
    provide: PurchasesProvider,
    deps: [
      AuthProvider,
      FirebaseToken.Firestore,
      FirebaseToken.Functions,
      FirebaseToken.RemoteConfig,
      TeamProvider,
    ],
    useFactory: (
      authProvider: AuthProvider,
      db: Firestore,
      functions: Functions,
      remoteConfig: RemoteConfig,
      teamProvider: TeamProvider,
    ) => new PurchasesDefaultProvider(authProvider, db, functions, remoteConfig, teamProvider),
  })
    .add(CancelSubscriptionInteractor, (p) => p.provideCancelSubscription())
    .add(ChangeSubscriptionInteractor, (p) => p.provideChangeSubscription())
    .add(CreateSubscriptionInteractor, (p) => p.provideCreateSubscription())
    .add(GetCustomerPortalUrlInteractor, (p) => p.provideGetCustomerPortalUrl())
    .add(GetPaymentMetadataInteractor, (p) => p.provideGetPaymentMetadata())
    .add(GetPaymentResultInteractor, (p) => p.provideGetPaymentResult())
    .add(GetPaywallDetailsInteractor, (p) => p.provideGetPaywallDetails())
    .add(GetUpgradeProrationInteractor, (p) => p.provideGetUpgradeProration())
    .add(SavePaymentMetadataInteractor, (p) => p.provideSavePaymentMetadata())
    .add(SyncTeamSubscriptionInteractor, (p) => p.provideSyncTeamSubscription())
    .add(WaitPurchaseWebhookInteractor, (p) => p.provideWaitPurchaseWebhook())
    .build(),
})
export class PurchasesProviderModule {}
